import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { notification } from 'antd'
import { FormikHelpers } from 'formik'
import {
  EmployeeFormData,
  useCreateEmployee,
} from '../../../services/api/employees'
import { isValidationError } from '../../../services/api/client/types'
import { employeePath } from '../../../routes/paths'
import { View } from './View'
import { useQuery } from '../../../utils/hooks/query'

export const Container: React.FunctionComponent = () => {
  const history = useHistory()
  const query = useQuery()
  const [createEmployee, { error }] = useCreateEmployee()
  const [form, setForm] = useState<EmployeeFormData>({
    companyId: query.get('company') || '',
    firstNameRu: '',
    middleNameRu: '',
    lastNameRu: '',
    skipMiddleName: false,
    firstNameEn: '',
    lastNameEn: '',
    gender: '',
    birthdate: '',
    countryCode: '',
    email: '',
    phoneNumber: '',
  })

  const onCompanyChange = (companyId?: string) => {
    setForm({ ...form, companyId: companyId || '' })
    companyId ? query.set('company', companyId) : query.delete('company')
    history.push({ search: '?' + query.toString() })
  }

  const onSubmit = (
    employeeData: EmployeeFormData,
    { setErrors }: FormikHelpers<EmployeeFormData>
  ) => {
    const newEmployee: EmployeeFormData = {
      ...employeeData,
      ...{
        middleNameRu: employeeData.skipMiddleName
          ? undefined
          : employeeData.middleNameRu,
        phoneNumber:
          employeeData.phoneNumber === ''
            ? undefined
            : employeeData.phoneNumber,
        email: employeeData.email === '' ? undefined : employeeData.email,
      },
    }

    return createEmployee(newEmployee)
      .then((response) => {
        history.push(employeePath(response.data?.id))
        notification.success({
          message: 'Сотрудник успешно создан',
          duration: 3,
        })
      })
      .catch((error) => {
        notification.error({
          message: 'Возникли ошибки при создании сотрудника',
          duration: 3,
        })
        if (isValidationError(error)) {
          setErrors(error.fieldErrors)
        }
      })
  }

  return (
    <View
      error={error}
      initialValues={form}
      onSubmit={onSubmit}
      onCompanyChange={onCompanyChange}
    />
  )
}
